// import { type ResourcesConfig } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '4ueu1j10lojmkdbdt4f2drv3aq',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'ap-northeast-1_2t1cvodNF'
    }
  }
};

export default awsConfig; 